import Script from 'next/script';

import { Wrapper } from './styles';

const TrueMedWidget: React.FC = () => {
	return (
		<Wrapper>
			<div
				id="truemed-prequalify"
				icon-height="12"
				data-public-id={process.env.NEXT_PUBLIC_TRUEMED_PUBLIC_QUALIFICATION_ID}
			/>
			{/*
			 * Load the TrueMed prequal widget only when this component renders
			 * (i.e. on payment surfaces that opt into HSA/FSA prequal).
			 * Previously this script was injected globally from LayoutScripts,
			 * which cost every page (incl. the homepage) a third-party request
			 * with no benefit. `afterInteractive` keeps it out of the LCP path.
			 */}
			<Script
				id="truemed-prequal-widget"
				src="https://truemed-public.s3.us-west-1.amazonaws.com/truemed-ads/prequal-widget.min.js"
				strategy="afterInteractive"
			/>
		</Wrapper>
	);
};

export default TrueMedWidget;
